import cn from 'clsx';
import type {ElementType, ReactNode} from 'react';

import typographyVariants, {type TypographyVariant} from './typographyVariants';

interface TextProps {
    children?: ReactNode;
    variant?: TypographyVariant;
    as?: ElementType;
    className?: string;
    id?: string;
    'aria-hidden'?: boolean;
}

const Text = ({children, variant = 'body', as: Tag = 'span', className, id, 'aria-hidden': ariaHidden}: TextProps) => {
    // Unauthored copy leaves no empty node behind to hold a gap or margin.
    if (children == null || children === '') return null;

    return (
        <Tag id={id} aria-hidden={ariaHidden} className={cn(typographyVariants[variant], className)}>
            {children}
        </Tag>
    );
};

export default Text;
